export interface TenantSupport {
  email?: string;
  url?: string;
}

export interface TenantSocialLinks {
  instagram?: string;
  x?: string;
  tiktok?: string;
  linkedin?: string;
  facebook?: string;
  youtube?: string;
}

export type SocialPlatform = keyof TenantSocialLinks;

export interface SocialLink {
  platform: SocialPlatform;
  url: string;
}

export interface SupportContact {
  href: string;
  label: string;
}

const PLATFORM_ORDER: SocialPlatform[] = [
  'instagram',
  'facebook',
  'x',
  'tiktok',
  'linkedin',
  'youtube',
];

const safeHttpsUrl = (value?: string) => {
  const candidate = value?.trim() ?? '';
  if (!candidate) return '';
  try {
    const url = new URL(candidate);
    return url.protocol === 'https:' && !url.username && !url.password
      ? url.href
      : '';
  } catch {
    return '';
  }
};

export const supportContact = (
  support: TenantSupport | undefined,
  brandName: string,
): SupportContact | undefined => {
  const brand = brandName.trim();
  const url = safeHttpsUrl(support?.url);
  if (url) {
    return {
      href: url,
      label: brand ? `Ir al soporte de ${brand}` : 'Ir al soporte',
    };
  }

  const email = support?.email?.trim() ?? '';
  if (!email) return undefined;

  return {
    href: `mailto:${email}`,
    label: brand ? `Escribir a ${brand}` : 'Escribir al soporte',
  };
};

export const socialLinkList = (
  links: TenantSocialLinks | undefined,
): SocialLink[] =>
  PLATFORM_ORDER.map((platform) => ({
    platform,
    url: safeHttpsUrl(links?.[platform]),
  })).filter((link) => link.url !== '');
